// IMPORT LIBS
import jQuery from 'jquery';
import Swiper from 'swiper';
import noUiSlider from 'nouislider';
import bootstrapBundle from '../../../node_modules/bootstrap/dist/js/bootstrap.bundle.js';
import "regenerator-runtime/runtime";

window.$ = jQuery;
window.jQuery = jQuery;
window.Swiper = Swiper;
window.noUiSlider = noUiSlider;
window.bootstrapBundle = bootstrapBundle;

// NEED TO USE "REQUIRE" IN THIS LIBRARY
const fancybox = require('../../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox');
window.fancybox = fancybox;

// IMPORT CLASSES
import Used from './classes/Used';

// IMPORT FUNCTIONS
import { tabsCreate, tabsInit } from './functions/tabs';
import { swipersInit } from './functions/sliders';
import { accordionsCreate, controlAccordionsFilter } from './functions/accordions';
import { showPartialsFixed } from './functions/partialsFixed';
import { buttonCotationBehavior, buttonFilterBehavior } from './functions/actionsForm';
import { showNavbarDropdown, showSidebarDropdown } from './functions/dropdowns';
import { sidebarFixedBehavior } from './functions/sidebarFixed';
import { controlDate } from './functions/controlDate';
import { redirectPage } from './functions/redirectPage';
import { handleSetMoreHeight } from './functions/setHeights';
import { chooseUnits } from './functions/chooseLocation';

document.addEventListener('DOMContentLoaded', function () {
  // FUNCTIONS TO CREATE AND INIT TABS
  tabsCreate();
  tabsInit();

  // FUNCTION TO CREATE AND INIT ACCORDIONS
  accordionsCreate();

  // FUNCTION TO INIT CHOOSE LOCATION
  chooseUnits();

  // FUNCTION TO CREATE AND INIT SWIPERS
  swipersInit();

  // FUNCTION TO CONTROL ACCORDIONS ON USED CARS FILTER
  controlAccordionsFilter();

  navButtonBehaviour();

  // FUNCTION TO CONTROL HEADER/FOOTER FIXED
  window.addEventListener('scroll', () => {
    showPartialsFixed('.header-fixed', 'show-header-scrolled', 'hide-header-scrolled');
    showPartialsFixed('.footer-fixed', 'show-footer-scrolled', 'hide-footer-scrolled');
    showPartialsFixed('.header-mobile.fixed', 'show-header-scrolled', 'hide-header-scrolled');
  });

  // FUNCTION TO CONTROL BEHAVIOR OF COTATION BUTTONS
  buttonCotationBehavior('.button-call-form');
  buttonCotationBehavior('.button-product-cotation');

  // FUNCTION TO CONTROL BEHAVIOR OF FILTERS BUTTONS
  buttonFilterBehavior('.button-call-filter');

  // const unitsSelect = document.querySelector('.units-select');
  // if(unitsSelect) {
  //   showNavbarDropdown('.navbar-link.units-select-dropdown', '.navbar-dropdown-list.units-select-dropdown', 0);
  // }

  // // FUNCTION TO CONTROL DROPDOWNS ONLY IN NAVBAR MENUS
  // showNavbarDropdown('.navbar-link.dropdownList', '.navbar-dropdown-list.dropdownList', 0);

  // // FUNCTION TO CONTROL DROPDOWNS ONLY IN SIDEBAR MENUS
  // showSidebarDropdown('.sidebar-link.dropdownList','.sidebar-link-dropdown.dropdownList', 0);

  // // FUNCTION TO CONTROL BEHAVIOR OF SIDEBAR FIXED
  // sidebarFixedBehavior('.sidebar');

  // FUNCTION TO INSERT CURRENT DATE IN INPUTS [TYPE=DATE]
  controlDate();

  // FUNCTION TO REDIRECT TO HOME PAGE
  redirectPage();

  // FUNCTION TO SET MORE HEIGHT AMONG THE ELEMENTS OF SAME TYPE
  handleSetMoreHeight('.js-sales-title', 992);
  handleSetMoreHeight('.js-promotion-name', 992);
  handleSetMoreHeight('.js-promotion-desc', 992);
  handleSetMoreHeight('.js-sales-req-title', 992);
  handleSetMoreHeight('.js-sales-req-desc', 992);
  handleSetMoreHeight('.js-sales-available-name', 0);
  handleSetMoreHeight('.js-sales-available-desc', 0);
  handleSetMoreHeight('.js-high-title', 992);
  handleSetMoreHeight('.js-high-desc', 992);

  const usedFilterData = document.querySelector('#used-filter-data');

  if (usedFilterData) {
    const dataFilter = usedFilterData.getAttribute('data-filter');
    const filters = JSON.parse(dataFilter);
    new Used(filters);
  }

  setFamily();
  getModelFromParams();
  changeTestDriveImage();
});

function setFamily() {
  let searchParams = new URLSearchParams(window.location.search);
  const modelname = searchParams.get('modelname');
  const selector = ".my-tabs[data-content='" + modelname + "']";
}

function getModelFromParams() {
  let searchParams = new URLSearchParams(window.location.search);
  const modelname = searchParams.get('modelname');

  if (modelname) {
    $('select#model').val(modelname);
    const imgWrapper = $('form .test-drive-form-img img');

    const img = $('select#model').find('option:selected').attr('data-image');
    imgWrapper.attr('src', img);
  }
}

function changeTestDriveImage() {
  const myInput = $('select#model');
  const imgWrapper = $('form .test-drive-form-img img');
  myInput.on('change', function (e) {
    const img = $(e.target).find('option:selected').attr('data-image');
    imgWrapper.attr('src', img);
  });
}

// FUNCTION TO UP TOP PAGE
$('.btn-scroll-top').on('click', function () {
  $('html,body').animate({ scrollTop: 0 }, '300')
});

// FUNCTION TO ADD OVERLAY ON MODALS
function popUp(selector) {
  $('body,html').addClass('scroll-lock');
  selector.fadeIn('fast');
}

function popClose(form) {
  form ? $('.modal-form').fadeOut() : $('.modal-overlay').fadeOut();
  $('body,html').removeClass('scroll-lock');
}

// FUNCTION TO PASS INFORMATION TO POP-UP PROMOTIONS
function modalInject(data, target) {
  const { title, img, text } = data;
  $(target).find('.promotion-title').html(title);
  $(target).find('.promotion-img').attr('src', img);
  $(target).find('.promotion-text').html(text);
  popUp($(target));
}

$('.btn-open-modal').on('click', function () {
  const el = $(this).data('target');
  const data = $(this).data('json');
  data ? modalInject(data, el) : popUp($(el));
})

// FUNCTION TO OPEN MODALS
$('.modal-overlay, .btn-close-modal').on('click', function (e) {
  $(e.target).hasClass('form-close') ? popClose(true) : popClose()
}).on('click', '.pop-up-content', function (event) {
  event.stopPropagation()
})

// FUNCTION TO CONTROL PAGINATIONS
let currentPage = 1;
let currentOrd = 'asc';

$('.order-control').on('click', function () {
  search(currentPage);
});

$('.page-link').on('click', function () {

  currentPage = $(this).data('page');
  $('.page-link').removeClass("active");
  $(this).addClass("active");
  search(currentPage);
});

$('.page-link').on('click', function () {
  currentPage = $(this).data('page');
  $('.page-item').removeClass("active");
  $(this.parentElement).addClass("active");

  if (currentPage != "1") {
    $('.left-arrow').removeClass("disabled");
  } else {
    $('.left-arrow').addClass("disabled");
  }

  search(currentPage);
});

function search(pageNum = 1) {
  async function busca() {
    currentOrd = $("#order").val();

    const result = await $.request('onGetPromotions', {
      data: { order: currentOrd, page: pageNum, limit: 15 },
      complete: function (res) {

      }
    });

    return result;
  }

  let a = busca().then(data => $("#promotions").html(data.result)).finally(
    function () {
      buttonCotationBehavior('.button-product-cotation');

      $('.btn-open-modal').on('click', function () {
        const el = $(this).data('target');
        const data = $(this).data('json');
        data ? modalInject(data, el) : popUp($(el));
      });
    }
  );
}



document.addEventListener('DOMContentLoaded', function () {
  let cor = document.querySelector(".cor")
  let versao = document.querySelector(".versao")

  if (cor || versao) {
    cor.value = document.querySelector('input[name=cor]:checked').value;
    versao.value = document.querySelector('input[name=versao]:checked').value;
  }
});

$(document).ready(function () {
  $(".versao-radio").find("input[type='radio']").click(function () {
    let entradaId = $(this).attr("id");
    if (document.getElementById(entradaId).checked) {
      $(".versao").val(document.getElementById(entradaId).value);
    }
  });
  $(".cor-radio").find("input[type='radio']").click(function () {
    let entradaId = $(this).attr("id");
    if (document.getElementById(entradaId).checked) {
      $(".cor").val(document.getElementById(entradaId).value);

    }
  });
  $(".entrada-radio").find("input[type='radio']").click(function () {
    let entradaId = $(this).attr("id");
    if (document.getElementById(entradaId).checked) {
      $(".entrada").val(document.getElementById(entradaId).value);

    }
  });
  $(".parcelas-radio").find("input[type='radio']").click(function () {
    let entradaId = $(this).attr("id");
    if (document.getElementById(entradaId).checked) {
      $(".parcelas").val(document.getElementById(entradaId).value);

    }

  });
  $(".parcela-final-radio").find("input[type='radio']").click(function () {
    let entradaId = $(this).attr("id");

    if (document.getElementById(entradaId).checked) {
      $(".parcela-final").val(document.getElementById(entradaId).value);

    }
  });
});

//Finds y value of given object
function findPos(obj) {
  var curtop = 0;
  if (obj.offsetParent) {
    do {
      curtop += obj.offsetTop;
    } while (obj = obj.offsetParent);
    return curtop;
  }
}

function navButtonBehaviour() {
  let anchorHanEv = document.getElementById('han-ev-anchor');
  let anchorTanEv = document.getElementById('tan-ev-anchor');
  let anchorD1 = document.getElementById('d1-anchor');
  let anchorPlusDm = document.getElementById('plus-dm-anchor');
  let anchorET3 = document.getElementById('et3-anchor');
  let anchorYuanPlus = document.getElementById('yuan-plus-anchor');

  anchorHanEv.addEventListener('click', () => { window.scroll(0, findPos(document.querySelector(".han-ev-section"))) });
  anchorTanEv.addEventListener('click', () => { window.scroll(0, findPos(document.querySelector(".tan-ev-section"))) });
  anchorD1.addEventListener('click', () => { window.scroll(0, findPos(document.querySelector(".d1-section"))) });
  anchorPlusDm.addEventListener('click', () => { window.scroll(0, findPos(document.querySelector(".plus-dm-section"))) });
  anchorET3.addEventListener('click', () => { window.scroll(0, findPos(document.querySelector(".song-special"))) });
  anchorYuanPlus.addEventListener('click', () => { window.scroll(0, findPos(document.querySelector(".yuan-plus-section"))) });
}

